import { gsap } from "gsap";
import cookies from "./cookies.js";

function pageTransition() {

  const transition_el = document.querySelector('.page-transition');
  const body_el = document.querySelector('body');
  const main_el = document.querySelector('main');

  // Si no existe el elemento de transición, salir
  if (!transition_el) {
    console.log('Page transition: elemento .page-transition no encontrado');
    return;
  }

  // Check if this is the first visit to mark as visited
  const isFirstVisit = !cookies.checkCookie('visited');
  console.log('Page transition: isFirstVisit =', isFirstVisit);

  // Mark as visited with a session cookie (expires when browser closes)
  if (isFirstVisit) {
    cookies.setCookie('visited', 'true', 0); // 0 days = session cookie
    // Set initial state - visible on page load
    gsap.set(transition_el, { y: "0%" });
    // Set initial main state for page load
    gsap.set(main_el, { y: "-8rem", opacity: 0 });
  }

  // Function to execute entrance animations
  const executeEntrance = () => {
    // Animate overlay out and main content in simultaneously
    /* ENTRADA */
    gsap.to(transition_el, {
      y: "100%",
      duration: 1,
      ease: "power4.inOut",
      onComplete: () => {
        // Animation completed
      }
    });

    gsap.to(body_el, {
      backgroundColor: "#fff",
      duration: 0,
    });

    gsap.to(main_el, {
      y: "0rem",
      duration: 1,
      ease: "power4.inOut"
    });

    gsap.to(main_el, {
      opacity: 1,
      duration: 0.1,
      ease: "power4.inOut"
    });
  };

  // Only execute entrance animation on first visit
  if (isFirstVisit) {
    let hasExecuted = false;
    
    const triggerAnimation = () => {
      if (!hasExecuted) {
        hasExecuted = true;
        setTimeout(executeEntrance, 1600); // pause para primera visita
      }
    };

    // Wait for everything to load including images and styles
    window.addEventListener('load', triggerAnimation);
    
    // Fallback: Si 'load' no se dispara en 3 segundos (común en mobile), ejecutar de todos modos
    setTimeout(() => {
      if (!hasExecuted) {
        console.log('Page transition: load event timeout, executing animation');
        triggerAnimation();
      }
    }, 3000);
  }

}

export default pageTransition